import React from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import NavbarV3 from "../../components/Navbar/NavbarV3";
import ImgWTitle from "../../components/ImgWTitle/ImgWTitle";
import HowItStarted from "../../components/HowItStarted/HowItStarted";
import WhoWeAre from "../../components/WhoWeAre/WhoWeAre";
import Footer from "../../components/Footer/Footer";
import ImgWTitle2 from "../../components/ImgWTitle/ImgWTitle2";
import { getLangUrls } from "../../utils/languageRouting";
const AboutUs = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const seo = getLangUrls("/about", location.pathname);
  return (
    <div>
      <Helmet>
        <html lang={seo.lang} />
        <title>{t("seo.about.title")}</title>
        <meta name="description" content={t("seo.about.description")} />
        <link rel="canonical" href={seo.canonical} />
        <link rel="alternate" hrefLang="fr" href={seo.hreflangFr} />
        <link rel="alternate" hrefLang="en" href={seo.hreflangEn} />
        <link rel="alternate" hrefLang="x-default" href={seo.hreflangFr} />
      </Helmet>

      <div className="d-flex flex-fill flex-column">
        <NavbarV3 />
        <ImgWTitle />
      </div>
      <div className="d-flex flex-fill flex-column">
        <HowItStarted />
        <WhoWeAre />
        <ImgWTitle2 />
        <Footer />
      </div>
    </div>
  );
};

export default AboutUs;
